import React, { Component } from 'react';
import dayjs from 'dayjs';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import { styled } from '@mui/material/styles';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(isBetweenPlugin);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
    weekStart: 1,
});

const CustomPickersDay = styled(PickersDay, { shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isHovered' })(({ theme, isSelected, isHovered, day }) => ({
    borderRadius: 0,
    ...(isSelected && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.main,
        },
    }),
    ...(isHovered && {
        backgroundColor: theme.palette.primary.light,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.light,
        },
        ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.primary.dark,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.dark,
        },
        }),
    }),
    ...(day.day() === 1 && {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    }),
    ...(day.day() === 0 && {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    }),
}));

const isInSameTimePeriod = (dayA, dayB, SelectedDate_Type) => {
    if (dayB == null) {
        return false;
    }

    return dayA.isSame(dayB, SelectedDate_Type);
};

class Day extends Component {
    render() {
        const { day, selectedDay, hoveredDay, SelectedDate_Type, ...other } = this.props;

        return (
            <CustomPickersDay
                {...other}
                day={day}
                sx={{ px: 2.5 }}
                disableMargin
                selected={false}
                isSelected={isInSameTimePeriod(day, selectedDay, SelectedDate_Type)}
                isHovered={isInSameTimePeriod(day, hoveredDay, SelectedDate_Type)}
            />
        );
    }
}

class WeekMonthPicker extends Component {
    state = {
        hoveredDay: null
    };

    handleDayHover = (day) => {
        this.setState({ hoveredDay: day });
    };

    handleDayLeave = () => {
        this.setState({ hoveredDay: null });
    };

    render() {
        const { hoveredDay } = this.state;
        var { SelectedDate, SelectedDate_Type } = this.props;

        return (
            <DateCalendar
                value={SelectedDate}
                onChange={this.props.OnSelectNewDate}
                showDaysOutsideCurrentMonth
                displayWeekNumber
                slots={{ day: Day }}
                slotProps={{
                    day: (ownerState) => ({
                        selectedDay: SelectedDate,
                        hoveredDay,
                        onPointerEnter: () => this.handleDayHover(ownerState.day),
                        onPointerLeave: this.handleDayLeave,
                        SelectedDate_Type
                    }),
                }}
            />
        );
    }
}

export default WeekMonthPicker;
